import { getPublicPortSuffix } from "./Enviroment";

export type T = string;

// The local s3 proxy is served by this workspace's nginx, so it needs the workspace port.
// Real S3 never does — it is a public host on 443, and appending a port there would break
// every deployed environment.
// Document URLs are built in the BROWSER as well as on the server, and the api scope reads
// `process.env`, which a browser does not have — asking for it there throws and takes the
// whole page down. Only a local stack on a non-443 port reaches the port lookup at all.
const portSuffix = (): string => getPublicPortSuffix(typeof window === "undefined" ? "api" : "web");

export const fromAccountAndBucketNames = (accountName: string, bucketName: string): string =>
    accountName === "propertybid-local"
        ? `https://s3-proxy.sailhomes.local${portSuffix()}/${accountName}-${bucketName}`
        : `https://s3.eu-west-2.amazonaws.com/${accountName}-${bucketName}`;

/* eslint-disable-next-line */
export enum bucketNames {
    LISTINGS_DOCUMENTS_BUCKET = "uploaded-documents",
    LISTINGS_IMAGES_BUCKET = "uploaded-images",
    SAIL_HOMES_CONTRACTS = "sh-contracts",
    SAIL_HOMES_ADDITIONAL_SERVICES_QUOTES = "sh-additional-services-quotes",
    SAIL_HOMES_CONTRACTS_AUTH_TO_SELL_VEHICLE = "sh-contracts-authority-to-sell-vehicle",
    UNIT_TEST_BUCKET = "unit-test-bucket",
    SAIL_LEGAL_DOCUMENTS = "sail-legal-documents-files",
    SAIL_LEGAL_EMAILS = "sail-legal-emails",
    SAIL_LEGAL_ID_CHECKS = "sail-legal-id-checks",
}
